import React from 'react';
import { Section } from './ui/Section';
import { Sun, Moon } from 'lucide-react';
export function Protocol() {
  return <Section data-id="element-105">
      <h2 className="text-3xl font-serif mb-12 text-center text-warm-brown" data-id="element-106">
        El mecanismo: Protocolo 7×7
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-107">
        {/* Morning Card */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gold/10 flex flex-col items-center text-center" data-id="element-108">
          <div className="bg-gold/10 p-4 rounded-full mb-6 text-gold" data-id="element-109">
            <Sun size={32} data-id="element-110" />
          </div>
          <h3 className="text-xl font-serif font-bold mb-2 text-warm-brown" data-id="element-111">
            7 minutos a la mañana
          </h3>
          <p className="text-sm uppercase tracking-widest text-sage font-bold mb-6" data-id="element-112">
            Aterrizar
          </p>

          <ul className="space-y-4 text-left w-full text-warm-brown/80" data-id="element-113">
            <li className="flex items-start gap-3" data-id="element-114">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gold flex-shrink-0" data-id="element-115"></span>
              <span data-id="element-116">Respiración breve</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-117">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gold flex-shrink-0" data-id="element-118"></span>
              <span data-id="element-119">Grounding con los sentidos</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-120">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gold flex-shrink-0" data-id="element-121"></span>
              <span data-id="element-122">Journaling guiado (no escribir por escribir)</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-123">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gold flex-shrink-0" data-id="element-124"></span>
              <span data-id="element-125">Micro-intención accionable (una decisión mínima)</span>
            </li>
          </ul>
        </div>

        {/* Evening Card */}
        <div className="bg-warm-brown text-cream p-8 rounded-2xl shadow-sm flex flex-col items-center text-center" data-id="element-126">
          <div className="bg-cream/10 p-4 rounded-full mb-6 text-cream" data-id="element-127">
            <Moon size={32} data-id="element-128" />
          </div>
          <h3 className="text-xl font-serif font-bold mb-2 text-cream" data-id="element-129">
            7 minutos a la noche
          </h3>
          <p className="text-sm uppercase tracking-widest text-gold font-bold mb-6" data-id="element-130">
            Vaciar
          </p>

          <ul className="space-y-4 text-left w-full text-cream/80" data-id="element-131">
            <li className="flex items-start gap-3" data-id="element-132">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gold flex-shrink-0" data-id="element-133"></span>
              <span data-id="element-134">Descarga física (mandíbula/hombros/manos)</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-135">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gold flex-shrink-0" data-id="element-136"></span>
              <span data-id="element-137">"Lista brutal" para sacar todo de la cabeza</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-138">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gold flex-shrink-0" data-id="element-139"></span>
              <span data-id="element-140">Reencuadre sin positivismo tóxico</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-141">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gold flex-shrink-0" data-id="element-142"></span>
              <span data-id="element-143">Cierre con frase ancla + gesto</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="text-center bg-sage-light/30 p-6 rounded-xl" data-id="element-144">
        <p className="font-serif text-lg mb-4 text-warm-brown" data-id="element-145">
          Te doy versión:
        </p>
        <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-146">
          <span className="px-4 py-1 bg-white border border-sage/20 rounded-full text-sm font-medium text-sage" data-id="element-147">
            Normal (7 min)
          </span>
          <span className="px-4 py-1 bg-white border border-sage/20 rounded-full text-sm font-medium text-sage" data-id="element-148">
            Plan B (2 min)
          </span>
          <span className="px-4 py-1 bg-white border border-sage/20 rounded-full text-sm font-medium text-sage" data-id="element-149">
            Modo supervivencia (30 seg)
          </span>
        </div>
        <p className="italic text-warm-brown/80" data-id="element-150">
          Porque si tu práctica depende de un día perfecto, no es práctica. Es
          fantasía.
        </p>
      </div>
    </Section>;
}